
import Milestones from "../employee-recognition/Milestones";

export { Page }

function Page() {
  return <Milestones />;
}
